import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaAngleLeft } from "react-icons/fa";

const BackButton = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="fixed z-50 top-0 left-0 p-2">
      <button 
        className="flex items-center text-black hover:text-secondary-700 font-bold px-2 py-2 rounded"
        onClick={handleGoBack}
      >
        <FaAngleLeft style={{ fontSize: '1.5rem' }} /> Back
      </button>
    </div>
  );
};

export default BackButton;
